document.addEventListener('alpine:init', () => {
  Alpine.store('videoLightbox', {
    open: false,
    embed: null,
    show(embed) {
      this.embed = embed;
      this.open = true;
    },
    close() {
      this.open = false;
      this.embed = null;
    },
  });
});
